import { FilterMenuConfig } from '../../types/filter.type';

export const LEVEL_FILTERS: FilterMenuConfig = {
  filters: [
    {
      type: 'checkbox',
      data: [
        {
          label: 'content_creation_preview.difficulty_level.expert',
          value: 'expert',
        },
        {
          label: 'content_creation_preview.difficulty_level.hard',
          value: 'hard',
        },
        {
          label: 'content_creation_preview.difficulty_level.medium',
          value: 'medium',
        },
        {
          label: 'content_creation_preview.difficulty_level.easy',
          value: 'easy',
        },
      ],
      unit: 'min',
    },
  ],
};
